import React, { useState, useEffect } from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  showTimeoutMessage?: boolean; // Show "Taking longer..." after 10s
  onCancel?: () => void; // Optional cancel button
  className?: string; // Allow custom className
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  message,
  showTimeoutMessage = false,
  onCancel,
  className = ''
}) => {
  const [showSlowMessage, setShowSlowMessage] = useState(false);
  const [showCancelOption, setShowCancelOption] = useState(false);

  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4'
  };

  useEffect(() => {
    if (!showTimeoutMessage) return;

    // Show "taking longer" message after 10 seconds
    const slowTimer = setTimeout(() => {
      setShowSlowMessage(true);
    }, 10000);

    // Show cancel option after 20 seconds
    const cancelTimer = setTimeout(() => {
      setShowCancelOption(true);
    }, 20000);

    return () => {
      clearTimeout(slowTimer);
      clearTimeout(cancelTimer);
    };
  }, [showTimeoutMessage]);

  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <div 
        className={`${sizeClasses[size]} border-primary-500 border-t-transparent rounded-full animate-spin`}
        role="status"
        aria-label="Loading"
      />
      {message && (
        <p className="text-gray-600 text-sm sm:text-base">{message}</p>
      )}
      {showSlowMessage && (
        <p className="text-amber-600 text-xs sm:text-sm mt-2 animate-fade-in">
          This is taking longer than expected...
        </p>
      )}
      {showCancelOption && onCancel && (
        <button
          onClick={onCancel}
          className="mt-2 text-xs sm:text-sm text-gray-600 hover:text-gray-800 underline"
        >
          Cancel
        </button>
      )}
    </div>
  );
};

